import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailNoTabPathRedirectRoute: InvariantJiraRoute = {
	name: 'software-version-detail-no-tab-path',
	path: '/projects/:projectKey/versions/:versionId',
};
